import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { format } from 'date-fns';

/**
 * Calendar header component with month navigation and day labels
 */
const CalendarHeader = ({ 
  currentMonth, 
  prevMonth, 
  nextMonth,
  mode = 'inbound'
}) => {
  // Theme color based on mode
  const themeColor = mode === 'inbound' ? 'blue' : 'green';
  
  // Get current month label (e.g., "January 2023")
  const monthLabel = format(currentMonth, 'MMMM yyyy');
  
  // Day name headers
  const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  
  return (
    <div className="mb-4">
      {/* Month navigation */}
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-bold text-slate-200 flex items-center">
          {monthLabel}
        </h2>
        <div className="flex">
          <button
            className={`mr-2 p-1 rounded-md hover:bg-slate-700 text-${themeColor}-400`}
            onClick={prevMonth}
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            className={`p-1 rounded-md hover:bg-slate-700 text-${themeColor}-400`}
            onClick={nextMonth}
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
      
      {/* Day name headers */}
      <div className="grid grid-cols-7 gap-1 mb-1">
        {dayNames.map((day) => (
          <div
            key={day}
            className="text-center text-xs text-slate-400 uppercase font-semibold py-2"
          >
            {day}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarHeader;